module.exports = __webpack_public_path__ + "static/media/talk.0a05ff76.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/talk.svg
 ** module id = 2109
 ** module chunks = 44
 **/